import type { OrganizationNumberCountry } from "../types/organization-number-country";

/**
 * Franchise org numbers at or above this threshold are Canadian offices.
 * This is not perfect. This will need to evolve as we add more countries.
 */
const CANADA_ORGANIZATION_NUMBER_THRESHOLD = 3000;

function getCountryFromOrganizationNumber(
  organizationNumber: string | undefined,
): OrganizationNumberCountry | undefined {
  if (!organizationNumber || !/^\d+$/.test(organizationNumber)) {
    return undefined;
  }

  return Number(organizationNumber) >= CANADA_ORGANIZATION_NUMBER_THRESHOLD
    ? "can"
    : "usa";
}

export { getCountryFromOrganizationNumber };
